module.exports = __webpack_public_path__ + "static/img/tipdmIntro-3.9c23971a.jpg";